import type { ParcelDocType } from '@ast-data/shared';

import { compareNatural } from '../../utils/compare';

/**
 * Label for a parcel: `Flurstücksnummer · Gemarkung · Gemeinde`.
 *
 * Both area levels, because a Gemarkung name is not unique — 532 Bavarian
 * Gemarkungen straddle several Gemeinden, so "1042 · Pechbrunn" can name two
 * different places in the same project.
 *
 * Falls back to the id, so an option is never a blank row.
 */
export function parcelPickerLabel(parcel: ParcelDocType): string {
    return (
        [parcel.parcelNumber, parcel.cadastralDistrict, parcel.municipality]
            .filter(Boolean)
            .join(' · ') || parcel.id
    );
}

/**
 * Parcel options for a picker, sorted by label — numerically, since a label
 * opens with a Flurstücksnummer: read as text, 18 would come before 7.
 */
export function parcelPickerOptions(
    parcels: ParcelDocType[]
): { value: string; label: string }[] {
    return [...parcels]
        .sort((firstParcel, secondParcel) =>
            compareNatural(
                parcelPickerLabel(firstParcel),
                parcelPickerLabel(secondParcel)
            )
        )
        .map((parcel) => ({
            value: parcel.id,
            label: parcelPickerLabel(parcel)
        }));
}
